module.exports = __webpack_public_path__ + "d8f1da4aa2cf30d78da0457124feec0e.png";